(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marlow-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-marlow-faq]')) roots.push(scope);
    scope.querySelectorAll('[data-marlow-faq]').forEach(function (root) {
      roots.push(root);
    });

    roots.forEach(function (root) {
      if (root.dataset.marlowFaqInitialized === 'true') return;
      root.dataset.marlowFaqInitialized = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-marlow-faq-item]'));
      var singleOpen = root.dataset.singleOpen === 'true';
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var animationDuration = reduceMotion ? 0 : 420;
      var controller = new AbortController();
      root._marlowFaqController = controller;
      root._marlowFaqItems = items;
      root.classList.add('is-animated');

      function syncItem(item, expanded) {
        var summary = item.querySelector('.marlow-faq__question');
        var answer = item.querySelector('.marlow-faq__answer');
        if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (answer) answer.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      }

      function closeItem(item, immediate) {
        window.clearTimeout(item._marlowFaqCloseTimer);
        item._marlowFaqCloseTimer = 0;
        item.classList.remove('is-expanded');
        syncItem(item, false);

        if (immediate || animationDuration === 0) {
          item.open = false;
          return;
        }

        item._marlowFaqCloseTimer = window.setTimeout(function () {
          item.open = false;
          item._marlowFaqCloseTimer = 0;
        }, animationDuration);
      }

      function openItem(item) {
        window.clearTimeout(item._marlowFaqCloseTimer);
        item._marlowFaqCloseTimer = 0;
        item.open = true;
        syncItem(item, true);

        window.requestAnimationFrame(function () {
          item.classList.add('is-expanded');
        });
      }

      items.forEach(function (item) {
        var summary = item.querySelector('.marlow-faq__question');
        if (!summary) return;

        if (item.open) {
          item.classList.add('is-expanded');
          syncItem(item, true);
        } else {
          syncItem(item, false);
        }

        summary.addEventListener('click', function (event) {
          event.preventDefault();
          if (item.classList.contains('is-expanded')) {
            closeItem(item);
            return;
          }

          if (singleOpen) {
            items.forEach(function (otherItem) {
              if (otherItem !== item && otherItem.classList.contains('is-expanded')) closeItem(otherItem);
            });
          }
          openItem(item);
        }, { signal: controller.signal });
      });
    });
  }

  if (window.__marlowFaqInitialize) {
    window.__marlowFaqInitialize(document);
    return;
  }

  window.__marlowFaqInitialize = initialize;
  initialize(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches('[data-marlow-faq]')
      ? event.target
      : event.target.querySelector('[data-marlow-faq]');
    if (!root) return;
    if (root._marlowFaqItems) {
      root._marlowFaqItems.forEach(function (item) {
        window.clearTimeout(item._marlowFaqCloseTimer);
      });
    }
    if (root._marlowFaqController) root._marlowFaqController.abort();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
